module.exports = __webpack_public_path__ + "img/we_translate_on_time_s.12889dec.png";